import i18n from "../../../../core/i18n";

const onlyValidEmailAllowed = i18n.tc("feedback.sign_up.only_email_allowed");
import { EMAIL_REGEX } from "@/modules/app/utils/regexes";

function validateEmail(_rule, value, callback) {
  if (EMAIL_REGEX.test(value)) {
    callback();
  } else {
    callback(new Error(onlyValidEmailAllowed));
  }
}

const emailRule = {
  validator: validateEmail,
  trigger: "blur",
};

export default {
  email: [{ ...emailRule }],
};
